import { render, staticRenderFns } from "./Account.vue?vue&type=template&id=580f29e0&scoped=true&"
import script from "./Account.vue?vue&type=script&lang=js&"
export * from "./Account.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "580f29e0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dmitrichiriuhin/code/pesoto-node/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('580f29e0')) {
      api.createRecord('580f29e0', component.options)
    } else {
      api.reload('580f29e0', component.options)
    }
    module.hot.accept("./Account.vue?vue&type=template&id=580f29e0&scoped=true&", function () {
      api.rerender('580f29e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Account/Account.vue"
export default component.exports